import React from 'react';

import { defineMessages, FormattedMessage } from 'react-intl-next';

import Lozenge from '@atlaskit/lozenge';
import { Text } from '@atlaskit/primitives';

import { isConfluenceDraft } from '../WorkActivityList/helper';

import { type WorkItemProps } from './types';
import * as Styled from './WorkItem.styled';

export const WorkItem = (props: WorkItemProps) => {
	const { provider, objectIconUrl, objectName, containerName, description, objectUrl, onClick } =
		props;

	const renderDraftStatus = () => {
		if (!isConfluenceDraft(provider, objectUrl)) {
			return null;
		}

		return (
			<Styled.LozengeWrapper>
				<Lozenge appearance="inprogress">
					<FormattedMessage {...messages.draft} />
				</Lozenge>
			</Styled.LozengeWrapper>
		);
	};

	const renderBody = () => {
		return (
			<Styled.Content>
				<Styled.ContentIcon src={objectIconUrl} alt="" />
				<Styled.Details>
					<Styled.DetailsHeadline>
						<Text as="p">{objectName}</Text>
						{renderDraftStatus()}
					</Styled.DetailsHeadline>

					<Styled.DetailsDescription>
						<Styled.ContainerName>{containerName}</Styled.ContainerName>
						<Styled.Description>{description}</Styled.Description>
					</Styled.DetailsDescription>
				</Styled.Details>
			</Styled.Content>
		);
	};

	return (
		<Styled.WorkItemLink href={objectUrl} onClick={onClick}>
			{renderBody()}
		</Styled.WorkItemLink>
	);
};

const messages = defineMessages({
	draft: {
		id: 'ptc-directory.profile-page.work-item.draft',
		defaultMessage: 'Draft',
		description:
			'A status of Confluence draft page. Draft pages are pages that have not yet been published. This text shows in a lozenge and in work list',
	},
});

export default WorkItem;
